import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set, get) => ({
      // State
      isAuthenticated: false,
      userType: null,
      userData: null,
      sessionStartTime: null,
      lastActivityTime: null,
      
      // Actions
      loginUser: (cardData) => {
        const now = Date.now();
        set({
          isAuthenticated: true,
          userType: 'user',
          userData: cardData,
          sessionStartTime: now,
          lastActivityTime: now,
        });
      },
      
      loginAdmin: (adminData) => {
        const now = Date.now();
        set({
          isAuthenticated: true,
          userType: 'admin',
          userData: adminData,
          sessionStartTime: now,
          lastActivityTime: now,
        });
      },
      
      logout: () => {
        set({
          isAuthenticated: false,
          userType: null,
          userData: null,
          sessionStartTime: null,
          lastActivityTime: null,
        });
        // Clear localStorage completely
        localStorage.removeItem('bidv-auth-storage');
      },
      
      updateActivity: () => {
        set({ lastActivityTime: Date.now() });
      },
      
      checkSessionTimeout: () => {
        const { lastActivityTime, sessionStartTime } = get();
        const now = Date.now();
        const TIMEOUT_MS = 120 * 1000; // 120 giây
        
        if (lastActivityTime && (now - lastActivityTime) > TIMEOUT_MS) {
          get().logout();
          return true;
        }
        
        if (sessionStartTime && (now - sessionStartTime) > TIMEOUT_MS) {
          get().logout();
          return true;
        }
        
        return false;
      },
      
      clearSession: () => {
        set({
          isAuthenticated: false,
          userType: null,
          userData: null,
          sessionStartTime: null,
          lastActivityTime: null,
        });
        localStorage.removeItem('bidv-auth-storage');
        // Also clear any other auth-related localStorage items
        localStorage.removeItem('bidv-auth-token');
        localStorage.removeItem('bidv-refresh-token');
        localStorage.removeItem('bidv-card-token');
      },
      
      // Force clear all session data
      forceClearSession: () => {
        set({
          isAuthenticated: false,
          userType: null,
          userData: null,
          sessionStartTime: null,
          lastActivityTime: null,
        });
        // Clear all localStorage items that start with 'bidv-'
        Object.keys(localStorage).forEach(key => {
          if (key.startsWith('bidv-')) {
            localStorage.removeItem(key);
          }
        });
      },
    }),
    {
      name: 'bidv-auth-storage',
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        userType: state.userType,
        userData: state.userData,
        sessionStartTime: state.sessionStartTime,
        lastActivityTime: state.lastActivityTime,
      }),
    }
  )
);

export { useAuthStore };
